<template>
    <v-card @click="Open"
            elevation="4"
            color="blue darken-3"
            dark
            class="text-sm-center"
            style="cursor:pointer;">
        <v-card-title>
            <h2 class="mx-auto my-0">Get Prepared</h2>
        </v-card-title>
        <v-card-title>
            <v-icon large class="mx-auto my-0">fas fa-school</v-icon>
        </v-card-title>
        <v-card-text>
            <div class="text-center">This area will give you access to our Welcome Hub which is full of useful information to help you start your learner journey</div>
        </v-card-text>
        <v-card-actions>
            <v-btn dark text block>Get Prepared Now</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        methods: {
            Open() { window.open('https://dundeeandangus.ac.uk/studying-at-da/welcome-hub/', '_blank'); }
        },
    }
</script>
